import React from 'react';
import PropTypes from 'prop-types';

const Collapse = ({className, color, size}) => {
  return (
    <svg
      className={className}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 512 512">
      <path
        d="M224,288v208l-80-80l-96,96L0,464l96-96l-80-80H224z M512,48l-96,96l80,80H288V16l80,80l96-96L512,48z"
        fill={color}
      />
    </svg>
  );
};

Collapse.defaultProps = {
  color: '#fff',
  size: 16,
  className: '',
};

Collapse.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default Collapse;
